// @ts-strict-ignore
import { InputBlock } from '@coast/schemas/index';
import React, { useCallback, useContext, useMemo } from 'react';
import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { getTypoComponent } from '@shared/components/blocks/utils';
import { ColorThemeContext } from '@shared/styles';
import { MBCardInputBlockBase } from './input/base';
import { renderToggle } from './input/utils';

interface Props {
  block: InputBlock;
}

export function MBCardInputBlockToggle({ block }: Props) {
  const colors = useContext(ColorThemeContext);
  const { setFieldValue, values } = useContext(CardFormContext);
  const TypoComponent = getTypoComponent(block.textStyle);

  const value = values[block.name];
  const onChange = useCallback(
    (updatedValue: boolean) => setFieldValue(block.name, updatedValue),
    [setFieldValue, block.name],
  );

  const renderRight = useMemo(() => () => renderToggle(value, onChange), [value, onChange]);

  return (
    <MBCardInputBlockBase block={block} renderLabel={null} renderRight={renderRight}>
      <TypoComponent color={colors.foregroundActive}>{block.label}</TypoComponent>
    </MBCardInputBlockBase>
  );
}
